const red = "#ee6f6a";
const pink = "#ffafaf";
const blue = "#6ca6ff";
const green = "#6cddae";
const secondary = "#8b8b8b";
const navbarHeight = "68px";
const boxShadow = `0 0 1px 0 rgba(0, 0, 0, 0.144),
        0 0.6rem 1rem 0 rgba(0, 0, 0, 0.151)`;

export const lightTheme = {
    style: "light",
    main: "#fff",
    notMain: "000",
    primary: "#494949",
    secondary: secondary,
    background: "#f6f6f6",
    strand: "#b5b5b5",
    modal: "#f2f2f2",
    modalTag: "#d1d1d1",
    modalTagText: "#7d7d7d",
    buttonBackground: "#fff",
    modeSelected: "#d3d3d3",
    modeHover: "#b7b7b7",
    red: red,
    pink: pink,
    blue: blue,
    green: green,
    iconBrightness: "brightness(0.2)",
    navbarHeight: navbarHeight,
    boxShadow: boxShadow,
    imageShine: red,
    hyperlink: "blue",
    svgWindow: "#fff",
    svgIcons: "#646464",
    svgTaskbar: "#ddd",
    svgSkillBkg: "#ddd",
    projectButtonHover: "#ddd"
};

export const darkTheme = {
    style: "dark",
    main: "#000",
    notMain: "#fff",
    primary: "#e4e4e4",
    secondary: secondary,
    background: "#292929",
    strand: "#b5b5b5",
    modal: "#1d1d1d",
    modalTag: "#8a8a8a",
    modalTagText: "#363636",
    buttonBackground: "#1d1d1d",
    modeSelected: "#444444",
    modeHover: "#888",
    red: red,
    pink: pink,
    blue: blue,
    green: green,
    navbarHeight: navbarHeight,
    boxShadow: boxShadow,
    imageShine: "#DDD",
    hyperlink: "lightBlue",
    svgWindow: "#191919",
    svgIcons: "#fff",
    svgTaskbar: "#222",
    svgSkillBkg: "#313131",
    projectButtonHover: "#202020"
};
